import MyRsmLogo from './MyRsmLogo'

export default MyRsmLogo
